import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Compmatchrankteam({
  kode_main,
  lapangan,
  tglmain,
  jammain,
  id,
}) {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const [pp1, setPP1] = useState([]);
  const [pp2, setPP2] = useState([]);

  const getdata1 = async () => {
    try {
      const response = await axios.get(
        urlapi + "Matchrankteam?kode_main=" + kode_main + "&&sesi=1"
      );
      setPP1(response.data);
    } catch (error) {}
  };

  const getdata2 = async () => {
    try {
      const response = await axios.get(
        urlapi + "Matchrankteam?kode_main=" + kode_main + "&&sesi=2"
      );
      setPP2(response.data);
    } catch (error) {}
  };

  const Logo = ({ team, size = 56 }) => {
    const [img, setImg] = useState([]);
    const getLogo = async () => {
      try {
        const response = await axios.get(
          urlapi + "Logoteamrankteam?team=" + team
        );
        setImg(response.data);
      } catch (error) {}
    };

    useEffect(() => {
      getLogo();
    }, [team]);

    return (
      <div className="rankmatch-logo-wrap">
        {img == null || !img.logo_team ? (
          <img
            src="/img/club.png"
            className="rankmatch-logo"
            alt="logo"
            style={{ width: size, height: size }}
          />
        ) : (
          <img
            src={img.logo_team}
            className="rankmatch-logo"
            alt={team}
            style={{ width: size, height: size }}
          />
        )}
        {img && img.pool ? (
          <span className="rankmatch-pool-badge">Pool {img.pool}</span>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    getdata1();
    getdata2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kode_main]);

  const renderMatchCard = (pp, sesi) => {
    const noLawan = pp.lawan === "" || pp.lawan == null;

    return (
      <div className="col-12">
        <div className="rankmatch-card">
          <div className="rankmatch-card-top">
            <div className="rankmatch-kicker">
              <span className="rankmatch-kicker-badge">
                <i className="fas fa-futbol"></i> Rank Team Sesi {sesi}
              </span>
              <span className="rankmatch-kicker-field">
                <i className="fas fa-location-dot"></i> {lapangan}
              </span>
            </div>
            <span className="rankmatch-kicker-game">Match #{id}</span>
          </div>

          <div className="rankmatch-card-body">
            {!noLawan ? (
              <>
                <div className="rankmatch-teams">
                  <Link
                    to={"/statistikteam/" + pp.team}
                    style={{ textDecoration: "none" }}
                    className="rankmatch-team"
                  >
                    <Logo team={pp.team} />
                    <span className="rankmatch-team-name">{pp.team}</span>
                  </Link>

                  <div className="rankmatch-vs">
                    <span className="rankmatch-vs-text">VS</span>
                  </div>

                  <Link
                    to={"/statistikteam/" + pp.lawan}
                    style={{ textDecoration: "none" }}
                    className="rankmatch-team"
                  >
                    <Logo team={pp.lawan} />
                    <span className="rankmatch-team-name">{pp.lawan}</span>
                  </Link>
                </div>
              </>
            ) : (
              <>
                <div className="rankmatch-empty">
                  <div className="rankmatch-empty-center">
                    <div className="rankmatch-empty-vs">VS</div>
                    <Link
                      to="/daftarteamrankteam"
                      style={{ textDecoration: "none" }}
                      className="rankmatch-empty-cta"
                    >
                      <i className="fas fa-bolt"></i> Daftar sebagai lawan
                    </Link>
                  </div>
                </div>
              </>
            )}

            <div className="rankmatch-card-meta">
              <span className="rankmatch-meta-item">
                <i className="far fa-calendar"></i> {pp.tgl_main || tglmain}
              </span>
              <span className="rankmatch-meta-item">
                <i className="far fa-clock"></i> {pp.jam_mulai || jammain} WIB
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="rankmatch">
      <div className="row g-3">
        <div className={pp1 == false ? "d-none" : ""}>
          {pp1 == false ? <></> : renderMatchCard(pp1, 1)}
        </div>
        <div className={pp2 == false ? "d-none" : ""}>
          {pp2 == false ? <></> : renderMatchCard(pp2, 2)}
        </div>
      </div>
    </div>
  );
}
